import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon-fire",
  "use": "icon-icon-fire-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 48 48\" id=\"icon-icon-fire\">\r\n<path d=\"M36,15.6l-3.6,3.6c0,0,0-14.4-12-19.2c0,0-1.2,13.2-7.2,18s-18,19.2,6,30c0,0-12-13.2,3.6-22.8c0,0-1.2,4.8,4.8,9.6\r\n\ts0,13.2,0,13.2S56.4,40.8,36,15.6z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-fire.svg
// module id = hin9
// module chunks = 60